
// events.js
import EventEmitter from 'events';

export const loginEvent = new EventEmitter();
